import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles'
import 'date-fns';
import {
  Button,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Fade,
  IconButton,
} from '@material-ui/core';
import FileUploaderDialog from './FileUploaderDialog';
// import DeleteDialog from "./DeleteDialog";
import TagDialog from "../items/form/TagDialog";
import FolderSelector from '../folders/FolderSelector';
import {buildFormData} from "../../../../state/actions/actionUtils";
import {API_ROOT} from "../../../../baseUrls";
import CloseIcon from "@mui/icons-material/Close";
import ConversionPoller from "../items/table/ConversionPoller";
import {getMindfileItemsDetails} from "../../../../state/actions/getDataActions";
import Keyword from "../../../util/common/Keyword";
import InfoText from "../../../util/common/InfoText";
import LoadingCircle from "../../../util/common/LoadingCircle";
import Alert from "@material-ui/lab/Alert";

const styles = {
  noteRows: {
    fontSize:'1.15em',
    marginBottom: '0.25em'
  },
  statusText: {
    fontWeight: 500,
    fontSize: '0.85em',
    opacity:'0.8',
    textTransform:'uppercase'
  },
  uploader:{
    '& button.filepond--action-revert-item-processing':{
      backgroundColor: '#ffffff99',
    }
  },
  saving: {
    fontSize: "18px",
    textAlign:"center"
  },
  savingText: {
    display: "inline-block",
    fontSize: "1.15rem",
    height: "48px",
    marginRight: "1rem",
    // verticalAlign: "middle",
    textTransform: "uppercase",
    fontWeight: 500,
    color: "rgba(0,0,0,0.52)",
  },
  savedStatus: {
    width: "fit-content",
    textAlign: "center",
    margin: "0 auto",
  },
  savedSuccess:{
    margin: "0.5rem",
    backgroundColor:'#FFF',
  },
};

class FileUploadDialog extends Component {
  state = {
    tagOpen: false,
    selectedFolder: this.props.addItemProps && this.props.addItemProps.folder ? this.props.addItemProps.folder : this.props.folderList[0],
    fileUploads: [],
    pendingUploads: [],
    savedItems: [],
    pendingMap: {},
    uploadCount: 0,
    selectedPendingUploadIds: [],
    tagStates: [],
    isDeleteDialogOpen: false,
    deletionInProgress: false,
    deletePromise:null,
    deleteFile:null,
    closeConfirmOpen: false,
    itemsSaved: false,
  };
  savedTimeout = null;
  filepondRef = React.createRef();

  updateItems(getNewItems){
    const newItems = getNewItems(this.state.pendingUploads);
    if(newItems !== null){
      this.setState({pendingUploads:newItems})
    }

    const newTags = getNewItems(this.state.tagStates);
    if(newTags !== null){
      this.setState({tagStates:newTags})
    }
  }

  handleClose(){
    if(this.state.uploadCount > 0 && this.props.itemChangeCallback){
      this.props.itemChangeCallback();
    }
    this.setState({fileUploads: [], pendingUploads:[], pendingMap: {}, uploadCount: 0, closeConfirmOpen: false})
    this.props.closeDialog();
  }

  addPendingUpload(upload){
    let newPendingMap = {...this.state.pendingMap};
    newPendingMap[upload.id] = upload;
    this.setState({pendingUploads: [...this.state.pendingUploads, upload], pendingMap: newPendingMap, uploadCount: this.state.uploadCount + 1});

    if(this.state.closeConfirmOpen && this.state.pendingUploads.length === this.state.fileUploads.length){
      this.handleClose();
    }
  }

  tagAllUploaded() {
    const targetUploads = this.state.pendingUploads;
    if (targetUploads.length > 0) {
      this.setState({
        tagOpen: true,
        tagStates: targetUploads
      });
    }
  }

  tagUploaded(file) {
    const targetUpload = this.state.pendingUploads.find(f => f.id === file.serverId);
    this.setState({
      tagOpen: true,
      tagStates: [{...targetUpload}],
    });
  }

  closeCloseConfirmDialog() {
    this.setState({ closeConfirmOpen: false });
  }

  openCloseConfirmDialog() {
    this.setState({ closeConfirmOpen: true });
  }

  // closeTagDialog() {
  //   this.setState({ tagOpen: false });
  // }
  //
  // openDeleteDialog() {
  //   this.setState({ isDeleteDialogOpen: true });
  // }
  //
  // confirmDelete(resolve, file) {
  //   if(typeof(this.state.deletePromise) === 'function') {
  //     this.state.deletePromise(false);
  //   }
  //   this.setState({isDeleteDialogOpen: true, deletePromise: resolve, deleteFile: file});
  // }
  //
  // cancelDelete() {
  //   if(typeof(this.state.deletePromise) === 'function') {
  //     this.state.deletePromise(false);
  //   }
  //   this.setState({ isDeleteDialogOpen: false, deletePromise: null, deleteFile:null });
  // }

  resolveDelete() {
    if(this.state.deleteFile && this.state.deleteFile.serverId) {
      this.setState({deletionInProgress: true});
      this.removeItems([this.state.deleteFile.serverId], () => {
        if(typeof(this.state.deletePromise) === 'function') {
          this.state.deletePromise(true);
        }
        this.setState({ isDeleteDialogOpen: false, deletePromise: null, deleteFile: null, deletionInProgress: false });
      });
    }
  }

  removeItems(itemIds, callback = () => {}) {
    // let ret = false;
    fetch(`${ API_ROOT }/mindfiles/${this.props.mindfile.id}/items/delete`, {
      method: 'DELETE',
      credentials: 'include',
      body: buildFormData({item_ids: itemIds}),
      headers: {'X-CSRF-Token': this.props.authenticityToken},
    }).then((resp) => resp.json())
    .then((data) => {
      // ret = (itemIds === data.removed_ids)
      this.setState({
        ...this.state,
        deletionInProgress: false,
        pendingUploads: [...this.state.pendingUploads.filter(file => !data.removed_ids.includes(file.id.toString()))]
      })
    })
    .catch(error => {
      console.error(error);
      return false;
    })
    .finally(() => callback());
    return true;
  }

  render() {
    const isOpen = this.props.isOpen
    const closeDialog = this.handleClose.bind(this);
    const maybeCloseDialog = () => {
      if(this.state.pendingUploads.length !== this.state.fileUploads.length){
        this.openCloseConfirmDialog();
      }else{
        this.handleClose();
      }
    };
    const savingInProgress = this.props.savingInProgress

    // console.log("disabled", this.state.pendingUploads.length === 0 || this.state.pendingUploads.length !== this.state.fileUploads.length || savingInProgress);
    return (<>
      <Dialog PaperProps={{id:"uploadFilesDialog"}} open={isOpen} fullWidth maxWidth="md">
        <DialogTitle>
          <div style={{display:'flex', flexWrap:'wrap-reverse', justifyContent:'space-between'}}>
            Upload Files
            <IconButton onClick={closeDialog} style={{width:'2rem', height:'2rem', margin:'-0.5rem 0 0 auto'}}>
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent className={this.props.classes.uploader}>
          <div style={{width: '15em'}}>
            <FolderSelector
              label="Folder"
              id="uploadFolder"
              selectedFolder={this.state.selectedFolder}
              folderList={this.props.folderList}
              addFolder={this.props.addFolder}
              handleFolderSelect={(newVal) => this.setState({...this.state, selectedFolder: newVal})}
            />
          </div>
          {this.props.savingInProgress ?
            <div className={this.props.classes.saving}>
              <span className={this.props.classes.savingText}>
                Saving in progress...
              </span>
              <LoadingCircle size="font" />
            </div>
            : null
          }
          <div className={this.props.classes.savedStatus}>
            <Collapse in={this.state.itemsSaved} timeout={100}>
              <Fade in={this.state.itemsSaved} timeout={100} onEnter={() => {
                if(this.savedTimeout){
                  clearTimeout(this.savedTimeout);
                }
                this.savedTimeout = setTimeout(() => this.setState({itemsSaved: false}), 3000);
              }}>
                <Alert id="savedSuccess" className={this.props.classes.savedSuccess} variant="outlined" severity="success">Items Saved</Alert>
              </Fade>
            </Collapse>
          </div>
          <FileUploaderDialog
            filepondRef={this.filepondRef}
            mindfileId={this.props.mindfile.id}
            selectedFolder={this.state.selectedFolder}
            authenticityToken={this.props.authenticityToken}
            onUploadComplete={(item) => this.addPendingUpload(item)}
            files={this.state.fileUploads}
            setFiles={(files) => this.setState({fileUploads: files})}
            tagFile={this.tagUploaded.bind(this)}
            removeItems={this.removeItems.bind(this)}
          />
          <div style={{textAlign:'center'}}>
            <InfoText style={{ fontSize:'1em', marginBottom: '0.25em' }}>
              Uploaded files are set to a <Keyword>Pending</Keyword> status. Tagging a file changes the status to <Keyword>Active</Keyword>.
            </InfoText>
            <InfoText>
              <div>
                Tap a completed upload to tag an individual file, or click <Keyword>Tag Uploaded Files</Keyword> to tag all files together.
              </div>
              <div>
                Pending items are saved but will not be used until tagged.
              </div>
            </InfoText>
          </div>
          <TagDialog
            mindfileUserLevel={this.props.mindfileUserLevel}
            id="uploadTag"
            authenticityToken={this.props.user.authenticityToken}
            open={this.state.tagOpen}
            closeDialog={() => this.setState({tagOpen: false})}
            items={this.state.tagStates}
            folderList={this.props.folderList}
            addFolder={this.props.addFolder}
            mindfileFilterValues={this.props.mindfileFilterValues}
            savingInProgress={this.props.savingInProgress}
            saveItems={(items, allStarted, allComplete) => {
              this.props.setSavingInProgress(true);
              this.setState({savingItems: [...this.state.savedItems, ...items.map(item => item.id)]})
              this.props.saveItems(items, (item) => this.setState((prevState, props) => {
                return ({
                  savedItems: [...prevState.savedItems, item.id]
                });
                }
              ),
              () => {
                try {
                  allStarted();
                }catch (e) {
                  console.error("save callback", e);
                }
                const saveItems = items.map(item => item.id);
                const remove = this.state.fileUploads.filter(p => saveItems.includes(p.serverId));
                remove.forEach(file => {
                  this.filepondRef.current.removeFile(file);
                })
              },
              () => {
                this.setState((prevState, props) => {
                  const pending = prevState.pendingUploads.filter(p => !prevState.savedItems.includes(p.id));
                  return {pendingUploads:pending, itemsSaved: true};
                });
                allComplete();
                // if(items.length > 1){
                //   this.handleClose();
                // }
              })
            }}
          />
          <ConversionPoller
            mindfileId={this.props.mindfile.id}
            itemList={this.state.pendingUploads}
            getMindfileItemsDetails={this.props.getMindfileItemsDetails.bind(this)}
            updateItems={this.updateItems.bind(this)}
          />
        </DialogContent>
        <DialogActions>
          <Button id="tagAllUploads" onClick={this.tagAllUploaded.bind(this)} variant="contained" color="primary" disabled={this.state.pendingUploads.length === 0 || this.state.pendingUploads.length !== this.state.fileUploads.length || savingInProgress}>
            Tag Uploaded Files
          </Button>
          <Button id="closeUpload" onClick={maybeCloseDialog} variant="contained" color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        PaperProps={{id:"uploadCloseConfirm"}}
        open={this.state.closeConfirmOpen}
        onClose={() => this.closeCloseConfirmDialog()}
      >
        <DialogTitle>
          <div style={{display:'flex', flexWrap:'wrap-reverse', justifyContent:'space-between'}}>
            File upload in progress
            <IconButton onClick={() => this.closeCloseConfirmDialog()} style={{width:'2rem', height:'2rem', margin:'-0.5rem 0 0 auto'}}>
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            File upload in progress.  Closing may result in canceled uploads.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            id="closeConfirm"
            variant="contained"
            color="primary"
            onClick={closeDialog}
          >
            Close
          </Button>
          <Button
            id="closeCancel"
            variant="contained"
            color="secondary"
            onClick={() => this.closeCloseConfirmDialog()}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>)
  }
}

const mapStateToProps = (state) => ({
  user: state.auth,
  mindfile: state.mindfile,
  mindfileUserLevel: state.mindfileUserLevel,
})

const mapDispatchToProps =  {
  getMindfileItemsDetails
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(FileUploadDialog));
